module.exports = __webpack_public_path__ + "media/images/stores1-bda49b39b4d9fafc24e2a938c9071d57.jpg";